import Joi from 'joi';
import { isEmpty, isPlainObject } from 'lodash';

export default function getValidation(schema = {}) {
  if (!isPlainObject(schema)) {
    throw new Error(`schema ${schema} should be a plain object`);
  }

  return (values = {}) => {
    if (isEmpty(values)) {
      return {};
    }

    const { error } = Joi.validate(values, schema, { abortEarly: false });

    if (!error) {
      return {};
    }

    const errors = {};

    error.details.forEach(detail => {
      errors[detail.path] = detail.message;
    });

    return errors;
  };
}
